import { useTranslation } from "react-i18next";
import { ContactUpdateInquiriesDefaultEndPage } from "./ContactUpdateInquiriesDefaultEndPage";

export const ContactUpdateInquiriesClosedPage = () => {
	const { t } = useTranslation();

	return (
		<ContactUpdateInquiriesDefaultEndPage
			headline={t("Contact update already completed")}
			text={t(
				"The feedback period for the contact update has already expired. If you would like to check your data, please contact us.",
			)}
		/>
	);
};
